import React from "react";
import { useParams, useNavigate } from "react-router-dom";
import { fetchNft, deleteNFT, updateNFT } from "../api";
import { useQuery, useQueryClient } from "react-query";
import Spinner from "../components/Spinner/Spinner";
import Image from "../components/Image/Image";
import Grid from "../components/Grid/Grid";
import parse from "html-react-parser";
import { GlobalContext } from "./../context/GlobalContext";
import moment from "moment";
import Table from "../components/Table/Table";
import { useNotifications } from "../helpers/useNotifications";
import formatNumber from "../helpers/formatNumber";

function formatString(str) {
  if (!str) return "";

  // 1️⃣ Unterstriche durch Leerzeichen ersetzen
  const withSpaces = str.replace(/_/g, " ");

  // 2️⃣ Ersten Buchstaben groß machen
  return withSpaces.charAt(0).toUpperCase() + withSpaces.slice(1);
}

const columns = [
  {
    label: "",
    field: "Key",
    colWidth: "50%",
    rowValue: (val, row) => formatString(val),
  },
  {
    label: "",
    field: "Value",
    colWidth: "50%",
    rowValue: (val, row) => {
      const formatedValue = row?.Key?.toLowerCase().includes("date")
        ? moment(val).format("DD.MM.YYYY hh:mm")
        : val;

      return <p>{formatedValue}</p>;
    },
  },
];

function NftInfo() {
  const createNotification = useNotifications();
  const queryClient = useQueryClient();
  const navigate = useNavigate();
  const { chain, contract, id } = useParams();
  const { isMobile } = React.useContext(GlobalContext);

  const [showNftEdit, setShowNftEdit] = React.useState(false);
  const [currentNft, setCurrentNft] = React.useState();

  const { data, isLoading } = useQuery(
    [`nft-info`],
    () => fetchNft(chain, contract, id),
    {
      enabled: !!chain && !!contract && !!id, // nur ausführen, wenn alle Werte truthy sind
    },
  );

  const nftAttributesData = React.useMemo(() => {
    if (data?.metadata?.attributes) {
      const attributesArray = Object.entries(data?.metadata?.attributes).map(
        ([key, value]) => ({
          Key: key,
          Value: value,
        }),
      );

      return attributesArray;
    }
    return [];
  }, [data?.metadata?.attributes]);

  React.useEffect(() => {
    if (data)
      setCurrentNft({
        chain: data?.chain,
        contract: data?.smartcontract,
        id: data?.id,
        date: data?.purchaseDate,
      });
  }, [data]);

  if (isLoading) return <Spinner />;

  return (
    <>
      <div className="article-main">
        <Grid>
          <Image
            className={`col-12 ${!isMobile && "text-center"}`}
            source={data?.image || data?.metadata?.image}
            height={isMobile ? null : 400}
          />
          <h4
            className="text-light col-12"
            onClick={() => {
              setShowNftEdit(true);
            }}
          >
            {data?.name || data?.metadata?.name}
          </h4>
          {/* Personal data */}
          <Grid>
            <div className="col-4 text-center">
              <p className="stockinfo-keyfacts-label text-muted">
                Gesamtwert €
              </p>
              <p className="stockinfo-keyfacts-value text-light">
                {data?.metadata?.price > 0
                  ? `${formatNumber(data?.metadata?.price)}`
                  : "-"}
              </p>
            </div>
            <div className="col-4 text-center">
              <p className="stockinfo-keyfacts-label text-muted">Blockchain</p>
              <p className="stockinfo-keyfacts-value text-light">
                {formatString(data?.chain)}
              </p>
            </div>
            <div className="col-4 text-center">
              <p className="stockinfo-keyfacts-label text-muted">ID</p>
              <p className="stockinfo-keyfacts-value text-light text-truncate">
                {data?.id}
              </p>
            </div>
          </Grid>
          {/* Description */}
          {data?.metadata?.description && (
            <div className="article-main">
              <h6 className="text-muted">Beschreibung</h6>
              <div id="meta-description" className={`text-light text-left`}>
                {parse(data?.metadata?.description)}
              </div>
            </div>
          )}
          {/* Attributes */}
          {data?.metadata?.attributes && (
            <div className="article-main">
              <h6 className="text-muted">Attribute</h6>
              <div style={{ marginTop: "-20px" }}>
                <Table data={nftAttributesData} columns={columns} />
              </div>
              {/* <div id="meta-description" className={`text-light text-left`}>
              {Object.entries(data?.metadata?.attributes).map(
                ([key, value]) => (
                  <div key={key}>
                    <strong>{key}:</strong> {value}
                  </div>
                )
              )}
            </div> */}
            </div>
          )}
        </Grid>
      </div>

      {/** Edit-Mode */}
      <div
        className={`offcanvas offcanvas-bottom article-secondary-mobile ${
          showNftEdit && "article-secondary-visible show"
        }`}
        tabIndex="-1"
        id="offcanvasBottom"
        aria-labelledby="offcanvasLabel"
      >
        <div className="offcanvas-header">
          <button
            type="button"
            className="btn-close-custom dismiss-active-or-focus"
          >
            <i
              className="icon-click icon-close bi bi-x-lg text-muted"
              onClick={() => setShowNftEdit((prev) => !prev)}
            />
          </button>
        </div>
        <div className="offcanvas-body article-secondary-scroll">
          <div className="article-secondary-info">
            <h5 className="text-dark text-muted">
              {data?.name || data?.metadata?.name}
            </h5>

            <div
              id="data-description"
              className="text-muted text-left article-base-description-active"
            >
              <form id="updateNft">
                <div className="form-group col-12">
                  <label className="text-dark" for="date">
                    Datum
                  </label>
                  <div className="input-group">
                    <input
                      type="date"
                      className="form-control"
                      id="date"
                      name="date"
                      value={currentNft?.date}
                      onChange={(e) =>
                        setCurrentNft((prev) => ({
                          ...prev,
                          date: e.target.value,
                        }))
                      }
                    />
                  </div>
                </div>
                <div style={{ marginLeft: "15px" }}>
                  <button
                    type="button"
                    className="btn btn-outline-danger"
                    style={{ marginRight: "5px" }}
                    onClick={() => {
                      deleteNFT(data?.chain, data?.smartcontract, data?.id)
                        .then((result) => {
                          createNotification("success", result.message);
                          queryClient.invalidateQueries(["nft-info"]);
                          setShowNftEdit(false);
                          navigate("/portfolio/nft");
                        })
                        .catch((err) => {
                          createNotification("error", err.message);
                        });
                    }}
                  >
                    Löschen
                  </button>
                  <button
                    type="submit"
                    className="btn btn-primary btn-search-custom dismiss-active-or-focus"
                    onClick={(e) => {
                      e.preventDefault();

                      if (currentNft) {
                        updateNFT(
                          data?.chain,
                          data?.smartcontract,
                          data.id,
                          currentNft?.date,
                        )
                          .then((result) => {
                            createNotification("success", result.message);
                            queryClient.invalidateQueries(["nft-info"]);
                            setShowNftEdit(false);
                          })
                          .catch((err) => {
                            createNotification("error", err.message);
                          });
                      } else {
                        createNotification("error", "Bitte alle Daten angeben");
                      }
                    }}
                  >
                    Speichern
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default NftInfo;
